import valueOutput, {RuleObj} from "./ValueOutput"
import React from "react"
import {makeAutoObservable} from "mobx"
import ReactTooltip from "react-tooltip"
import {Link} from "react-router-dom"


export default class Attribute {
    private _data: AttributeData
    private _category_id: number
    private is_dictionary_loaded: boolean

    constructor(category_id: number, data: AttributeData) {
        this._data = data
        this._category_id = category_id
        this._destination = new valueOutput(data.destination, this)
        this.is_dictionary_loaded = data.is_dictionary_loaded
        makeAutoObservable(this)
    }

    private _destination: valueOutput

    get destination(): valueOutput {
        return this._destination
    }

    get isRequried(): boolean {
        return !!this._data.destination.is_required
    }

    get additionalComponents() {
        let component = null
        const hasDictionaryAndValue = this._data.has_dictionary
        if (hasDictionaryAndValue) {
            const compared = !this._destination.isCompared
            component = <div>
                <Link
                    to={'/category/' + this._category_id + '/attribute/' + this._data.id}
                    style={{color: compared ? "" : "red"}}
                    data-tip={true}
                    data-for={this._destination.category_id + "" + this.destination.ozon_attribute_id}
                > Сопоставить значения</Link>
                {!compared &&
                <ReactTooltip id={this._destination.category_id + "" + this.destination.ozon_attribute_id}>
                    Не выбрана характеристика
                </ReactTooltip>}
            </div>
        }

        return component
    }

    getComponent(index: string) {
        return this._destination.getComponent(index)
    }
}

export interface AttributeData {
    description: string
    destination: RuleObj
    group_id: number
    group_name: string
    id: number
    is_collection: number
    name: string
    type: string
    has_dictionary: boolean
    is_dictionary_loaded: boolean
}